import { gql } from 'graphql-request'

export const GET_EBOOKS_BY_USER = gql`
  query GetEbooksTitleAndIdByUser($searchText: String) {
    getEbooksTitleAndIdByUser(searchText: $searchText) {
      ebookId
      ebookTitle
    }
  }
`
